import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-remove-dialog',
  templateUrl: './remove-dialog.component.html',
  styleUrls: ['./remove-dialog.component.scss']
})
export class RemoveDialogComponent {

  constructor(
    public dialogRef: MatDialogRef<RemoveDialogComponent>,

    @Inject(MAT_DIALOG_DATA) public data: { id: string },
  ) {}

  onConfirm(id: string) {
    this.dialogRef.close({ id: id });
  }
}
